goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_clockwise_svg");
goog.provide("module$shadow_js_shim_module$src$svg$arrows$arrow_clockwise_svg");
shadow.js.shim.module$src$svg$arrows$arrow_clockwise_svg = shadow.js.nativeProvides["src/svg/arrows/arrow-clockwise.svg"] = shadow$bridge("src/svg/arrows/arrow-clockwise.svg");
module$shadow_js_shim_module$src$svg$arrows$arrow_clockwise_svg.default = shadow.js.shim.module$src$svg$arrows$arrow_clockwise_svg;
